import React from "react";
import Styles from "./index.module.scss";

interface ButtonProps {
  name: String;
  type?: "primary" | "secondary";
  style?: Object;
  styleBtn?: Object;
  disabled?: boolean;
  buttonType?: "submit" | "button" | "reset";
  onClick?: () => void;
}

function Button({
  name,
  styleBtn,
  style,
  type,
  onClick,
  buttonType,
  disabled,
  ...props
}: ButtonProps) {
  if (type === "secondary") {
    return (
      <div {...props} style={style} className={Styles.buttonSecondary}>
        <button
          disabled={disabled || false}
          style={styleBtn}
          onClick={onClick}
          type={buttonType || "button"}
        >
          {name}
        </button>
      </div>
    );
  }

  return (
    <div {...props} style={style} className={Styles.buttonPrimary}>
      <button
        style={styleBtn}
        onClick={onClick}
        type={buttonType || "button"}
        disabled={disabled || false}
      >
        {name}
      </button>
    </div>
  );
}

export default Button;
